import AdjustWeb from '@adjustcom/adjust-web-sdk'

import { ADJUST_WEB_TOKEN, IS_PRODUCTION } from '@/init/settings'
import { platform } from '@/services/platform'

/**
 * Initialize the Adjust Web SDK.
 */
export async function initAdjustWeb(): Promise<void> {
  const info = await platform.deviceInfo()
  if (info.platform !== 'web') {
    return
  }

  const environment = IS_PRODUCTION ? 'production' : 'sandbox'
  const config: AdjustWeb.InitOptions = {
    appToken: ADJUST_WEB_TOKEN,
    environment: environment,
  }
  if (!IS_PRODUCTION) {
    config.logLevel = 'verbose'
  }
  AdjustWeb.initSdk(config)
}
